export default __webpack_public_path__ + "static/media/202.ba2fef2c.gif";